import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  uploadItemValidate,
  upload,
  getExport,
} from "./sellInAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk("sellIn/fetchData", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchSellIn = createAsyncThunk("sellIn/fetchSellIn", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchId = createAsyncThunk("sellIn/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "sellIn/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("sellIn/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("sellIn/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "sellIn/removeById",
  async (payload) => {
    console.log(payload, "payload");
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "sellIn/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "sellIn/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);
export const fetchExport = createAsyncThunk(
  "sellIn/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const sellInSlice = createSlice({
  name: "sellIn",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchSellIn.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchSellIn.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = sellInSlice.actions;

export const selectData = (state) => state.sellIn.data;
export const selectSellIn = (state) => state.sellIn.data;
export const selectId = (state) => state.sellIn.dataId;
export const selectLoading = (state) => state.sellIn.loading;
export const selectError = (state) => state.sellIn.error;
export const selectPageNo = (state) => state.sellIn.pageNo;
export const selectPageSize = (state) => state.sellIn.pageSize;
export const selectTotalRecord = (state) => state.sellIn.totalRecord;
export const selectSelected = (state) => state.sellIn.selected;
export const selectResult = (state) => state.sellIn.result;

export default sellInSlice.reducer;
